import styled from 'styled-components';

import { media } from 'utils/detection';
import H1 from 'components/H1';

export default styled(H1)`
  position: relative;
  color: ${props => props.theme.textSemiDark};
  font-family: 'Galano Classic';
  font-size: 27px;
  font-weight: 400;
  width: 100%;
  margin: 0 0 8px 0;

  ${media.medium`
    font-size: 3.7vw;
    margin: 2vw 0;
    width: auto;
    flex: 1;
    order: 2;
    white-space: nowrap;
  `}
`;
